import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import ArticleContent from '../../../../../components/articleContent';
import SeoSummary from '../../../../../components/seoSummary';

class MainContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        pluginData: PropTypes.object,
        articleSummary: PropTypes.string,
    };

    render() {
        const { content, pluginData, articleSummary } = this.props;

        return (
            <div className={styles.main_content}>
                <SeoSummary summary={articleSummary} />
                {content.contentList ? (
                    <ArticleContent content={content} pluginData={pluginData} handleSelectTxt={this.handleSelectTxt} />
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(MainContent);
